<div class="onboarding-header">
  <div class="onboarding-header-title">
    <tidy-text [title]="'Schedule a Free Advanced Setup Call'" />
  </div>
  <div>
    <button mat-button fill="clear" color="primary" style="min-width: 0px" (click)="closeModal()">
      <tidy-text [body]="'X'" />
    </button>
  </div>
</div>
<tidy-divider />

<div class="advanced-setup-content">
  <div>
    <tidy-button
      class="secondary"
      [action]="boundScheduleCall"
      [text]="'Schedule Call'" />
  </div>
</div>
